import {
  Box,
  Breakpoint,
  DialogTitle,
  Grid,
  Slide,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Controller } from '..';
import { useForm } from 'react-hook-form';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

type Status = {
  value: string;
  label: string;
  disabled: boolean;
};

interface DialogDriverBaseProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onCancel?: () => void;
  children?: React.ReactNode;
  maxWidth?: Breakpoint | false;
  disableTransition?: boolean;
  isVisible?: boolean;
  colorConfirm?: string;
  fullWidth?: boolean;
  isDisabledBtn?: boolean;
  listStatus?: Status[]; //TODO: fix type
  ids: string[];
  onSubmit: (data: IDriverBaseApproveForm & { ids: string[] }) => void;
  value?: IDriverUpdate;
  isCheckAll?: boolean;
}

const DialogDriverBase: FC<DialogDriverBaseProps> = ({
  open,
  title,
  confirmText = 'common.save',
  cancelText = 'common.cancel_label',
  onCancel,
  maxWidth,
  disableTransition,
  isVisible = true,
  colorConfirm,
  fullWidth = true,
  isDisabledBtn = false,
  listStatus = [],
  ids,
  onSubmit,
  value,
  isCheckAll = false,
}) => {
  const { t } = useTranslation();
  const { handleSubmit, control, getValues, reset } =
    useForm<IDriverBaseApproveForm>({
      defaultValues: value ?? {
        isAlert: false,
        note: '',
        status: isCheckAll ? 'pending' : '',
      },
    });
  const { note, isAlert, status } = getValues();

  useEffect(() => {
    if (value) {
      reset(value);
    }
  }, [value, reset]);

  const handleOnSubmit = (data: IDriverBaseApproveForm) => {
    onSubmit({
      ...data,
      ids,
    });
  };
  return (
    <Dialog
      component='form'
      fullWidth={fullWidth}
      open={open}
      TransitionComponent={disableTransition ? undefined : Transition}
      maxWidth={maxWidth}
      onSubmit={handleSubmit(handleOnSubmit)}
    >
      {title && (
        <DialogTitle>
          <Typography
            sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'left' }}
          >
            {t(title)}
          </Typography>
        </DialogTitle>
      )}

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <Grid container sx={{ justifyContent: 'space-between' }}>
                <Grid item xs={7}>
                  <Controller
                    variant='Select'
                    control={control}
                    name='status'
                    value={status}
                    placeholder='common.select_status'
                    options={listStatus}
                  />
                </Grid>
                <Grid
                  item
                  xs={5}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Controller
                    variant='Switch'
                    control={control}
                    name='isAlert'
                    label='pre_registration_detail.entryAlert'
                    checked={isAlert}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Controller
                variant='TextField'
                control={control}
                name='note'
                placeholder='pre_registration_detail.note_placeholder'
                value={note}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center' }}>
        {isVisible && (
          <Button
            title={t(cancelText)}
            onClick={onCancel}
            typeName='secondary'
          />
        )}
        <Button
          type='submit'
          title={t(confirmText)}
          sx={{
            background: colorConfirm,
          }}
          disabled={isDisabledBtn}
          typeName='primary'
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogDriverBase;
